var r = Array.isArray;
const a = r;
export {
  a as default
};
